import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseRentIndexationTemplates = [
  {
    id: '-121001',
    language: Language.EN,
    subject: 'Annual rent indexation',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENT_INDEXATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>In accordance with the lease located at <strong>{{getLeaseMainAddress lease}}</strong>, having taken effect on <strong>{{formatDate lease.startDate}}</strong> your rent will be indexed.</p>
        <p>Please find all the details of the calculation and the effective date of indexation in attachment.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Comment:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Thank you for taking this into account and to adjust the periodical amount of your direct debit.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-121002',
    language: Language.FR,
    subject: 'Indexation annuelle du loyer',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENT_INDEXATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Conformément au bail sis <strong>{{getLeaseMainAddress lease}}</strong> et ayant pris effet le <strong>{{formatDate lease.startDate}}</strong>, votre loyer sera indexé.</p>
        <p>Je vous prie de trouver tous les détails du calcul ainsi que la date de prise d'effet de l'indexation en pièce jointe.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Commentaire:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Merci de bien vouloir prendre ces détails en considération et d'ajuster votre domiciliation périodique.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-121003',
    language: Language.NL,
    subject: 'Jaarlijkse indexering van de huurprijs',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENT_INDEXATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>In overeenstemming met het huurcontract gelegen op <strong>{{getLeaseMainAddress lease}}</strong> ingegaan op <strong>{{formatDate lease.startDate}}</strong> wordt uw huur geïndexeerd.</p>
        <p>Alle details over de berekening en de ingangsdatum van de indexering vindt u in de bijlage.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Opmerking:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Dank u om hiermee rekening te houden en het periodieke bedrag van uw domiciliëring aan te passen.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
      `,
  },
  {
    id: '-121004',
    language: Language.DE,
    subject: 'Jährliche Mietindexierung',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENT_INDEXATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>In Übereinstimmung mit dem Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>, der am <strong>{{formatDate lease.startDate}}</strong> in Kraft getreten ist, wird Ihre Miete indexiert.</p>
        <p>Bitte finden Sie alle Details der Berechnung und das Datum des Inkrafttretens der Indexierung im Anhang.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Kommentar:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Vielen Dank, dass Sie dies berücksichtigen und den periodischen Betrag Ihrer Lastschrift anpassen.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
